<template>
    <div class="banner">
        <!-- <el-carousel :interval="5000" arrow="always" height="600px">
            <el-carousel-item v-for="item in 4" :key="item">
            <h3>{{ item }}</h3>
            </el-carousel-item>
        </el-carousel> -->
        <img :src="topImg" v-if="topImg && topImg.indexOf('http') != -1" alt="">
        <img :src="$ImgUrl + topImg" v-if="topImg && topImg.indexOf('http') == -1" alt="">
        <img src="../../assets/static/index/default.png" v-if="!topImg" alt="">
    </div>
</template>

<script>
    export default {
        props: {
            topImg: String
        }
    }
</script>

<style lang="scss" scoped>
.banner {
    width: 100%;
    height: 600px;
    margin: 0 auto;
    img {
        width: 100%;
        height: 600px;
    }
}
</style>